export default "__VITE_ASSET__DPiRFEAM__"